import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

const IconButtonWithMarginCompensation = styled(IconButton)({
  marginTop: -12,
  marginBottom: -12,
});

export default IconButtonWithMarginCompensation;
